const ALLOWED_PROTOCOLS: readonly string[] = ['http:', 'https:'] as const;
export const urlValidator = (urlString: string): boolean => {
  try {
    const url = new URL(urlString);
    return ALLOWED_PROTOCOLS.includes(url.protocol);
  } catch {
    return false;
  }
};
